import type { ContentType, VirtualFile } from "@pdfking/pdfengine"
import { GuidToString, UInt8Hash } from "@pdfking/tfunc"
import { CreateRemoteFile } from "@pdfking/workflow/actions/pdfengine/Functions"

export default async (
  transfer: File
): Promise<{ path: string; file: VirtualFile }> => ({
  path: transfer.name,
  file: await CreateRemoteFile({
    guid: await transfer
      .arrayBuffer()
      .then(b => UInt8Hash([new Uint8Array(b)]))
      .then(GuidToString),
    mirrors: [URL.createObjectURL(transfer)],
    type: transfer.type as ContentType,
  }),
})
